import LoginEmail from '../components/loginpage/LoginEmail';

const LoginPage = () => {
    return (
        <>
            <LoginEmail />
        </>
    );
};

export default LoginPage;
